/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InvoiceCompanyDto } from './InvoiceCompanyDto';
import type { InvoicePremiumFundingDetailsDto } from './InvoicePremiumFundingDetailsDto';
import type { InvoiceProductSnapshotDto } from './InvoiceProductSnapshotDto';
export type InvoiceResponseDto = {
    id: string;
    invoiceNumber: string;
    invoiceSequence: number;
    clientId: string;
    clientName: string;
    policyId: string;
    policyMtaVersion?: number | null;
    productSnapshot?: InvoiceProductSnapshotDto | null;
    premiumFundingDetails?: InvoicePremiumFundingDetailsDto | null;
    issueDate: string;
    dueDate: string;
    status: InvoiceResponseDto.status;
    type: InvoiceResponseDto.type;
    amount: number;
    policyNetTotal?: number;
    policyTotalTax?: number;
    paid: number;
    outstanding: number;
    invoicePaid: boolean;
    invoicePaidAt?: string | null;
    commissionPaid: boolean;
    commissionPaidAt?: string | null;
    insurerPaid: boolean;
    insurerPaidAt?: string | null;
    paymentMethod: InvoiceResponseDto.paymentMethod;
    paymentType: InvoiceResponseDto.paymentType;
    insurer: InvoiceResponseDto.insurer;
    assignedAdviserId?: string | null;
    assignedAdviserName?: string | null;
    policy?: Record<string, any> | null;
    createdAt: string;
    updatedAt: string;
    company?: InvoiceCompanyDto;
};
export namespace InvoiceResponseDto {
    export enum status {
        DRAFT = 'DRAFT',
        APPROVED = 'APPROVED',
        AWAITING_PAYMENT = 'AWAITING_PAYMENT',
        PART_PAID = 'PART_PAID',
        OVERDUE = 'OVERDUE',
        FAILED = 'FAILED',
        PAID = 'PAID',
        REFUNDED = 'REFUNDED',
        WRITTEN_OFF = 'WRITTEN_OFF',
        VOID = 'VOID',
    }
    export enum type {
        ANNUAL = 'ANNUAL',
        INSTALMENT = 'INSTALMENT',
        ADJUSTMENT = 'ADJUSTMENT',
        RENEWAL = 'RENEWAL',
        MTA = 'MTA',
    }
    export enum paymentMethod {
        DIRECT_DEBIT = 'DIRECT_DEBIT',
        CREDIT_CARD = 'CREDIT_CARD',
        BANK_TRANSFER = 'BANK_TRANSFER',
        OTHER = 'OTHER',
        PREMIUM_FUNDING = 'PREMIUM_FUNDING',
    }
    export enum paymentType {
        FUNDED = 'FUNDED',
        ANNUAL = 'ANNUAL',
    }
    export enum insurer {
        ANDO = 'ANDO',
    }
}

